import React from "react";

const Choose = () => {
  return (
    <>
      <section id="choose">
        <div class="chooseBg">
          <div class="position-relative z-2" data-aos-duration="2000">
            <h4>Why choose us</h4>
            <h2>Let Us Show You The Beauty Of The World</h2>
            <div class="globalBtn mt-lg-5 mt-md-5">
              <ul>
                <li>
                  <link To="https://html-templates.evonicmedia.com/adventurist/contact.html" />
                  contact us
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <link />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="chooseCrads position-relative z-2">
          <div class="container">
            <div class="row gap-md-0 gap-4 justify-content-center card-text">
              <div class="col-lg-3 col-md-4" data-aos-delay="100">
                <div>
                  <figure>
                    <img
                      src="https://html-templates.evonicmedia.com/adventurist/assets/images/icon/choose-1.svg"
                      alt="chooseIcon"
                    />
                  </figure>
                  <h6>Tour and Travel</h6>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit sed
                    do eiusmod tempor incididunt
                  </p>
                </div>
              </div>
              <div class="col-lg-3 col-md-4" data-aos-delay="500">
                <div>
                  <figure>
                    <img
                      src="https://html-templates.evonicmedia.com/adventurist/assets/images/icon/choose-2.svg"
                      alt="chooseIcon"
                    />
                  </figure>
                  <h6>campus</h6>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit sed
                    do eiusmod tempor incididunt
                  </p>
                </div>
              </div>
              <div class="col-lg-3 col-md-4" data-aos-delay="900">
                <div>
                  <figure>
                    <img
                      src="https://html-templates.evonicmedia.com/adventurist/assets/images/icon/choose-3.svg"
                      alt="chooseIcon"
                    />
                  </figure>
                  <h6>Adventure Tour</h6>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit sed
                    do eiusmod tempor incididunt
                  </p>
                </div>
              </div>
              <div
                class="col-lg-3 col-md-4 d-lg-block d-none"
                data-aos-delay="1300"
              >
                <div>
                  <figure>
                    <img
                      src="https://html-templates.evonicmedia.com/adventurist/assets/images/icon/choose-4.svg"
                      alt="chooseIcon"
                    />
                  </figure>
                  <h6>photography</h6>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit sed
                    do eiusmod tempor incididunt
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Choose;
